// WHY (#1057): CONTAINER drafts replace the destination-city
// multiselect with a single free-text delivery address (the carrier
// scope is request-wide so per-city routing is meaningless). Lives as
// its own component so DraftBasicsCard stays a thin branch between the
// STANDARD and CONTAINER editors and so unit tests can exercise the
// controlled-input behaviour in isolation.
//
// @aiPurpose Edit the container-only `deliveryAddress` slot on the
//   draft scratchpad.
// @aiInvariant Pushes the typed value verbatim into the store via
//   `patchDraftHeader({ deliveryAddress })`; the wire `draft-save`
//   trims the string and the completeness gate enforces non-empty
//   on send.

import { useTranslation } from 'react-i18next';
import { Textarea } from '../../../ui/index.js';
import { useRequestsStore } from '../store.js';
import type { DraftScratchpad } from '../types.js';

export const DELIVERY_ADDRESS_MAX = 2000;

export function DeliveryAddressField({ d }: { d: DraftScratchpad }) {
  const { t } = useTranslation(['requests']);
  const patchHeader = useRequestsStore((s) => s.patchDraftHeader);
  return (
    <div data-testid="delivery-address-field">
      <Textarea
        ariaLabel={t('requests:draft.deliveryAddress.label')}
        value={d.deliveryAddress ?? ''}
        onChange={(value) => {
          if (value.length === 0) {
            patchHeader({ deliveryAddress: null });
            return;
          }
          // WHY (#1057): cap at the wire-side `max(2000)` mirror so a
          //   paste cannot overflow before save lands a 4xx.
          const next =
            value.length > DELIVERY_ADDRESS_MAX ? value.slice(0, DELIVERY_ADDRESS_MAX) : value;
          patchHeader({ deliveryAddress: next });
        }}
        placeholder={t('requests:draft.deliveryAddress.placeholder')}
        rows={3}
      />
    </div>
  );
}
